import { getCredentials } from '../infra/config/storage';

export const urlBase = process.env.REACT_APP_API;

export const userCredentials = () => {
  return getCredentials();
};
